import { render } from "./DirectorySelectorDialog.vue?vue&type=template&id=39c84d73&scoped=true"
import script from "./DirectorySelectorDialog.vue?vue&type=script&lang=js"
export * from "./DirectorySelectorDialog.vue?vue&type=script&lang=js"

import "./DirectorySelectorDialog.vue?vue&type=style&index=0&id=39c84d73&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c84d73"]])

export default __exports__